import { Diagram } from './Diagram';
import fourChecksSvg from '../../diagrams/four-checks.svg';

/**
 * Build-time Mermaid-rendered diagram of the four-check audit flow.
 * Used in Lesson 1.4 teaching section after the four CheckCards.
 *
 * Source: src/diagrams/four-checks.mmd
 * Rendered by: scripts/build-diagrams.mjs (runs before vite build via npm scripts)
 * Result: src/diagrams/four-checks.svg → imported as a Vite static asset URL.
 */
export function FourChecksDiagram() {
  return (
    <Diagram
      figure="1.4"
      title="The four-check audit flow"
      caption="Run the checks in order. Any failure ends the audit early: verify, fix, or throw out before continuing."
      ariaLabel="A top-to-bottom decision flow starting with an AI answer. Four sequential check nodes (Date, Source, Reasoning, Confidence), each branching to either continue down or to a 'Audit failed: verify, fix, or throw out' endpoint. If all four checks pass, the flow reaches 'Audit passed: worth trusting.'"
    >
      <img
        src={fourChecksSvg}
        alt="The four-check audit flow, rendered as a decision diagram."
        className="mx-auto block w-full max-w-2xl"
        style={{ maxHeight: 'min(80vh, 820px)' }}
      />
    </Diagram>
  );
}
